import {Feed, RemoteFeed} from './feeds.types';
import {DateTime} from 'luxon';
import {CLEnumKeys, CLEnumsMapper} from 'common/src/modules/enums/enums.types';
import {toClientMappingRule} from '../locationFeed/locationFeed.dataConverter';
import _omit from 'lodash/omit';

function toClientFeed(remoteFeed: RemoteFeed): Feed {
  return {
    ..._omit(remoteFeed, ['lastUploadDate', 'createTime']),
    ...(remoteFeed.lastUploadDate && {
      lastUploadDate: DateTime.fromISO(remoteFeed.lastUploadDate),
    }),
    ...(remoteFeed.createTime && {
      createTime: DateTime.fromISO(remoteFeed.createTime),
    }),
    mapping: {
      ...remoteFeed.mapping,
      rules: remoteFeed.mapping?.rules?.map(toClientMappingRule) || [],
    },
  };
}

function toClientFeedDefaultImagesOptions(
  data: number,
  feedsEnums: Record<string, CLEnumsMapper>,
): string {
  return feedsEnums[CLEnumKeys.Feeds.DefaultImages]?.byValue[data].uiName;
}

export {toClientFeed, toClientFeedDefaultImagesOptions};
